import type { ReactNode } from "react";

import { UsageAnalyticsDataContext } from "./UsageAnalyticsDataContext";

type Props = UsageAnalyticsDataContext & {
  children: ReactNode;
};

export const UsageAnalyticsDataContextProvider = ({ children, ...rest }: Props) => (
  <UsageAnalyticsDataContext.Provider value={{ ...rest }}>{children}</UsageAnalyticsDataContext.Provider>
);
